import { mapBasePicture } from './BasePicture.mappers';
export const mapPictureFile = (file, baseFile) => {
  const basePicture = mapBasePicture(file, baseFile);
  return {
    mediaType: 'picture',
    fileOutput: null,
    ...basePicture
  };
};
//# sourceMappingURL=Picture.mappers.js.map